import React from "react";
import { useSelector } from "react-redux";
import HeaderLeft from "../../../containers/logged_user_components/structure_components/desktop_screens/header_component/header_left/header_left";
import changeCourseChevron from "../../../utilities/images/study_dashboard/change_course_chevron.svg";
import "./DashboardChangeCourseButton.css";

const DashboardChangeCourseButton = () => {
  const userPreference = useSelector((state) => state.userPreference);
  const userData = useSelector((state) => state.auth.user);

  return (
    <div className="dashboard-change-course">
      <HeaderLeft
        userPreference={userPreference}
        userData={userData}
        redirectToDashboardOnUpdate={false}
        showBatchLabel={false}
        buttonText="Change Course"
        buttonClassName="dashboard-change-course__btn"
        buttonIcon={changeCourseChevron}
      />
    </div>
  );
};

export default DashboardChangeCourseButton;
